import { fetch } from "src/services/apollo-fetch";
import { Query } from "./_api";

export default {
    async fetchReceiptLog({ commit, state }, data) {
        // don't refetch, use cache
        if (state.selectedReceiptLog.id === data.id) {
            return;
        }

        const response = await fetch.query({
            query: Query.receiptLog,
            variables: { id: data.id },
        });
        commit("setSelectedReceiptLog", response.data.receiptLog);
    },
};
